import { normalizeId, parseNumericId } from './id-utils.js';
import { isValidMilitaryTime, sortMessagesByPath } from './message-tree.js';

export const normalizeRemoteConversationMessages = (rawMessages = [], allCharacters = []) => {
  const configCharacterNameMap = new Map(
    (Array.isArray(allCharacters) ? allCharacters : [])
      .map((character) => [normalizeId(character?.id ?? character?.characterId), character?.name])
      .filter(([id, name]) => id && typeof name === 'string' && name.trim().length > 0)
  );

  const transformedMessages = (Array.isArray(rawMessages) ? rawMessages : []).map((msg, index) => {
    const createdAt = msg.createdAt || msg.timestamp || Date.now();
    const path = msg.path !== undefined ? String(msg.path) : String(index + 1);
    const role = msg.role || (msg.characterId != null ? 'assistant' : 'user');
    const normalizedCharacterId = normalizeId(msg.characterId);
    const resolvedCharacterName = configCharacterNameMap.get(normalizedCharacterId) || null;
    const resolvedOutfitId = parseNumericId(msg.outfitId);
    const resolvedActionId = parseNumericId(msg.actionId);
    const resolvedActionNameRaw = typeof msg.actionName === 'string'
      ? msg.actionName
      : (typeof msg.action_name === 'string' ? msg.action_name : '');
    const resolvedActionName = resolvedActionNameRaw.trim() || null;
    const locationId = parseNumericId(msg.locationId ?? msg.location_id);
    const time = parseNumericId(msg.time);
    const resolvedTime = isValidMilitaryTime(time) ? time : null;
    const isGreeting = msg.isGreeting === true || msg.isInitialGreeting === true;
    return {
      role,
      content: msg.content ?? '',
      path,
      createdAt,
      ...(role === 'assistant' ? {
        characterId: normalizedCharacterId,
        characterName: resolvedCharacterName,
        outfitId: resolvedOutfitId,
        actionId: resolvedActionId,
        ...(resolvedActionName ? { actionName: resolvedActionName } : {})
      } : {}),
      ...(locationId != null && locationId >= 0 ? { locationId } : {}),
      ...(resolvedTime != null ? { time: resolvedTime } : {}),
      ...(isGreeting ? { isGreeting: true, isInitialGreeting: true } : {}),
      persistedRemote: true
    };
  });

  const sortedMessages = sortMessagesByPath(transformedMessages);
  const seen = new Set();
  const deduped = [];
  for (const message of sortedMessages) {
    const key = message.path;
    if (!key || !seen.has(key)) {
      if (key) seen.add(key);
      deduped.push(message);
    }
  }
  return deduped;
};
